import { HttpClient } from './httpClient'

export interface User {
  _id: string
  username: string
  email: string
  roles: string[]
  acl: {
    createDevice: boolean
  }
  createdAt?: string
  updatedAt?: string
}

export interface CreateUserData {
  username: string
  email: string
  password: string
}

export interface UpdateUserData {
  username: string
  email: string
  currentPassword?: string
  newPassword?: string
  role?: 'user' | 'admin'
}

/**
 * Clase para manejar las operaciones con usuarios
 */
export class UserService {
  /**
   * Método para obtener todos los usuarios (solo admin)
   */
  static async getUsers(): Promise<User[]> {
    return HttpClient.get<User[]>('/users')
  }

  /**
   * Método para obtener un usuario por su ID
   */
  static async getUserById(userId: string): Promise<User> {
    return HttpClient.get<User>(`/users/${userId}`)
  }

  /**
   * Método para crear un nuevo usuario (solo admin)
   */
  static async createUser(userData: CreateUserData): Promise<User> {
    return HttpClient.post<User>('/users', userData)
  }

  /**
   * Método para actualizar un usuario
   */
  static async updateUser(
    userId: string,
    userData: UpdateUserData,
  ): Promise<User> {
    return HttpClient.put<User>(`/users/${userId}`, userData)
  }

  /**
   * Método para eliminar un usuario (solo admin)
   */
  static async deleteUser(userId: string): Promise<boolean> {
    await HttpClient.delete(`/users/${userId}`)
    return true
  }
}
